import React from 'react'
import Captcha from './Components/Captcha'
import FeedbackCom from './../Components/FeedbackCom'
import { CustomerText } from '../CustomerText'
import Icons from './Images'
import { ModalInfo } from './Components/ModalInfo'
import Config from '../Config'
const { Language, ModalTip, FeedBackTag, FeedBackSelect, FeedBackUpload, platform, Pushgtagpiwikurl, Pushgtagdata } = Config()
const { Info } = ModalTip

let tempText = CustomerText[Language]


export default class CustomerService extends React.Component {
    constructor(props) {
        super(props)
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();
        this.state = {
            imageData: null
        };
    }


    shouldComponentUpdate(nextProps) {
        return false
    }


    readFile(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const base64String = fileReader.result.split(',')[1]; // Extract base64 content
                const result = {
                    fileName: file.name,
                    fileBytes: base64String,
                    fileSize: file.size
                };
                resolve(result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };

            fileReader.readAsDataURL(file); // Read file as data URL (base64)
        });
    };




    //开启相机
    async imageCamera(event) {
        const file = event?.target?.files[0];
        let data = {}
        if (file) {
            try {
                const { fileName, fileBytes, fileSize } = await this.readFile(file);
                data = { fileName, fileBytes, fileSize }
            } catch (error) {
                this.uploadImgErr({
                    text1: tempText?.text64,
                    text2: tempText?.text62
                })
                return
            }
        } else {
            this.uploadImgErr({
                text1: tempText?.text64,
                text2: tempText?.text62
            })
            return
        }

        return data
    }

    //开启相册
    async imageGallery(event) {
        let file = event.target.files[0];
        let fileName = file.name;

        const readFile = (file) => {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = function (event) {
                    let base64 = event.target.result.split(',')[1];
                    let data = { fileName: fileName, fileBytes: base64, fileSize: file.size };
                    resolve(data);
                };
                reader.onerror = function (error) {
                    reject(error);
                };
                reader.readAsDataURL(file);
            });
        };

        let data = {}
        try {
            data = await readFile(file);
        } catch (error) {
            this.uploadImgErr({
                text1: tempText?.text64,
                text2: tempText?.text62
            })
            return
        }
        return data
    }

    uploadImgErr({ text1 = '', text2 = '' }) {
        Info({
            children: ModalInfo(text1),
            okBtnTxt: text2,
            okFuntion: () => {
                okFunction()
            },
        })
    }


    render() {
        const { questionTypes, Header, getFeedBackLeaveStatus, onLeft } = this.props
        return <div className='feedbackContainer'>
            <FeedbackCom
                getFeedBackLeaveStatus={getFeedBackLeaveStatus}
                Header={Header}
                questionTypes={questionTypes}
                Captcha={({ onSubmit, isShowCaptcha, userName }) => {
                    return <Captcha onSubmit={onSubmit} isShowCaptcha={isShowCaptcha} userName={userName}></Captcha>
                }}
                Content={({
                    questionTypesIndex,
                    questionTypes,
                    onSelect,
                    changeQuestionInputText,
                    questionInputText,
                    uploadImageData,
                    maxLength,
                    onSubmit,
                    selectUplodType,
                    isAllowUploadImg,
                    submitBtnStatus,
                    isQuestionModalVisible,
                    isUploadModalVisible,
                    accept
                }) => {
                    return <FeedBackTag
                        tempText={tempText}
                        onLeft={onLeft}
                        className="feedbackModalContainer">
                        <img
                            src={Icons.submission}
                            className="submission"
                        ></img>

                        <div className="viewBox">
                            <div className="fileTitle">{tempText?.text9}</div>
                            <FeedBackSelect
                                questionTypes={questionTypes}
                                questionTypesIndex={questionTypesIndex}
                                tempText={tempText}
                                onSelect={onSelect}
                                isQuestionModalVisible={isQuestionModalVisible}
                            >
                                <div className="fileBoxCom fileBox" onClick={() => {
                                    onSelect({
                                        isQuestionModalVisible: true,
                                        questionTypesIndex: questionTypesIndex
                                    })
                                }}>
                                    <div className="fileText" style={{
                                        color: questionTypesIndex >= 0 ? '#222' : '#BCBEC3',
                                    }}>{questionTypesIndex >= 0 ? questionTypes[questionTypesIndex]?.questionType : tempText?.text15}</div>
                                    <div className="arrowIcon downArrow"></div>
                                </div>
                            </FeedBackSelect>
                        </div>

                        <div className="viewBox">
                            <div className="fileTitle">{tempText?.text12}</div>
                            <textarea
                                // multiline
                                maxLength={maxLength}
                                value={questionInputText}
                                className="fileBoxCom fileInputBox"
                                // onChangeText={questionInputText => {
                                //     changeQuestionInputText(questionInputText)
                                // }}
                                onChange={event => {
                                    changeQuestionInputText(event.target.value)
                                }}
                            ></textarea>
                            <div className="inputLimitBox">
                                <div className="inputLimitText">{`${questionInputText.length}/${maxLength}`}</div>
                            </div>
                        </div>


                        <div className="viewBox">
                            <div className="fileTitleBox">
                                <div className="fileTitle">{tempText?.text19}</div>
                                <div className="fileTitleIcon">{tempText?.text20}</div>
                            </div>
                            <div>
                                {
                                    Array.isArray(uploadImageData) && !!uploadImageData.length &&
                                    uploadImageData.map((v, i) => {
                                        return <div
                                            key={i}
                                            onClick={() => {
                                                Info({
                                                    title: tempText?.text36,
                                                    isShowCloseBtn: true,
                                                    children: <div>
                                                        <img
                                                            src={'data:img/png;base64,' + v?.fileBytes}
                                                            className="modaluploadImg"
                                                        ></img>
                                                        <div className="modaluploadImgName">{v?.fileName}</div>
                                                    </div>
                                                })
                                            }}
                                            className="uploadFileBytesImg">
                                            <div className="deleteImgBox" onClick={(event) => {
                                                event.stopPropagation(); // 阻止事件冒泡
                                                selectUplodType({
                                                    type: 'delete',
                                                    uploadImgIndex: i,
                                                    isUploadModalVisible: false
                                                })
                                            }}>
                                                <img
                                                    src={Icons.delete}
                                                    className="deleteImg"
                                                ></img>
                                            </div>
                                            <img
                                                src={'data:img/png;base64,' + v?.fileBytes}
                                                className="uploadFileBytesImg"
                                            ></img>
                                        </div>
                                    })
                                }
                            </div>
                            {
                                isAllowUploadImg &&
                                <FeedBackUpload
                                    isUploadModalVisible={isUploadModalVisible}
                                    selectUplodType={selectUplodType}
                                    accept={accept}
                                    tempText={tempText}
                                    imageCamera={this.imageCamera.bind(this)}
                                    imageGallery={this.imageGallery.bind(this)}
                                >
                                    <div
                                        onClick={() => {
                                            selectUplodType({
                                                isUploadModalVisible: true
                                            })
                                        }}
                                        className="uploadBtn">
                                        {
                                            platform == 'Web' &&
                                            <input
                                                value=""
                                                type="file"
                                                accept={accept}
                                                capture={''}
                                                className='Modal_file_btn'
                                                onChange={async (event) => {
                                                    let data = await this[`imageGallery`](event)
                                                    selectUplodType({
                                                        isUploadModalVisible: false,
                                                    })

                                                    if (!(!!data && !!Object.keys(data).length)) return

                                                    selectUplodType({
                                                        type: 'add',
                                                        uploadData: data,
                                                        isUploadModalVisible: false,
                                                        callBack: ({ text1 = '', text2 = '' }) => {
                                                            Info({
                                                                children: ModalInfo(text1),
                                                                okBtnTxt: text2,
                                                                okFuntion: () => {
                                                                    okFunction()
                                                                },
                                                            })
                                                        }
                                                    })


                                                    Pushgtagpiwikurl('help_center_give_feedback', 'Help Center Give Feedback')
                                                    Pushgtagdata('HelpCenter', 'UploadDocument', 'HelpCenter_C_UploadDocument')
                                                }}
                                            >
                                            </input>
                                        }
                                        <img
                                            src={Icons.upload}
                                            className="uploadImg"
                                        ></img>
                                        <div className="uploadText">{tempText?.text21}</div>
                                    </div>
                                </FeedBackUpload>
                            }


                            <div className="uploadTipList">
                                <div className="uploadTipCirlce"></div>
                                <div className="uploadTipText">{tempText?.text22}</div>
                            </div>
                            <div className="uploadTipList">
                                <div className="uploadTipCirlce"></div>
                                <div className="uploadTipText">{tempText?.text23}</div>
                            </div>
                            <div className="uploadTipList">
                                <div className="uploadTipCirlce"></div>
                                <div className="uploadTipText">{tempText?.text24}</div>
                            </div>
                        </div>


                        <div className="submitBtn" style={{ backgroundColor: submitBtnStatus ? '#00A6FF' : '#E3E3E3' }} onClick={() => {
                            submitBtnStatus && onSubmit()

                            if (submitBtnStatus) {
                                Pushgtagpiwikurl('help_center_give_feedback', 'Help Center Give Feedback')
                                Pushgtagdata('HelpCenter', 'SubmitFeedback', 'HelpCenter_S_Feedback', false,
                                    [
                                        {
                                            customVariableKey: "HelpCenter_S_Feedback_Category",
                                            customVariableValue: questionTypes[questionTypesIndex]?.questionType
                                        },
                                        {
                                            customVariableKey: "HelpCenter_S_Feedback",
                                            customVariableValue: questionInputText
                                        },
                                    ]
                                )
                            }

                        }}>
                            <div className="submitBtnText" style={{ color: submitBtnStatus ? '#fff' : '#999' }}>{tempText?.text25}</div>
                        </div>
                    </FeedBackTag>
                }}
            ></FeedbackCom>
        </div>
    }
}